import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import collateralService from "services/collateral/collateralService";

export const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
    showMessage: false,
    redirect: "",
    token: localStorage.getItem(AUTH_TOKEN) || null,
    result: {},
    getPageSize: "",
    getPageIndex: "",
    getCount: "",
    statusRespon: 0,
    total: 0,

    docRecList: [],
    docRecDetail: {},
    cabinetList: [],
    cabinetBoxList: [],
    detailEdit: {},
    listApprovalRec: [],
    listIssue: [],
    listApprovalIssue: [],
    listChangeLoc: [],
    listApprovalChangeLoc: [],
    logHistory: {},
    listInquiry:[],
};

export const docReceive = createAsyncThunk(
    'collateral/docReceive',
    async (payload, thunkAPI) => {
        try {
            const response = await collateralService.getDocReceiveList(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const docReceiveDetail = createAsyncThunk(
    'collateral/docReceiveDetail',
    async (loanId, thunkAPI) => {
        try {
            return await collateralService.getDocReceiveDetail(loanId);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getCabinetList = createAsyncThunk(
    'collateral/getCabinetList',
    async (payload, thunkAPI) => {
        try {
            const response = await collateralService.getCabinetList(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getCabinetBoxList = createAsyncThunk(
    'collateral/getCabinetBoxList',
    async (payload, thunkAPI) => {
        try {
            const response = await collateralService.getCabinetBoxList(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

//save request saveLoanAsset 
export const saveLoanAsset = createAsyncThunk(
    'collateral/saveLoanAsset',
    async (payload, thunkAPI) => {
        try {
            const response = await collateralService.saveLoanAsset(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

//edit doc receive 
export const getDetailEdit = createAsyncThunk(
    'collateral/getDetailEdit',
    async (docrcvTransactionId, thunkAPI) => {
        try {
            const response = await collateralService.getDetailEdit(docrcvTransactionId);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

//putRequestApproval
export const putRequestApproval = createAsyncThunk(
    'collateral/putRequestApproval',
    async (listReq, thunkAPI) => {
        try {
            const response = await collateralService.putRequestApproval(listReq);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getRecApprovalList = createAsyncThunk(
    'collateral/getRecApprovalList',
    async (userInput, thunkAPI) => {
        try {
            const response = await collateralService.getRecApprovalList(userInput);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const putApprovedDocRcv = createAsyncThunk(
    'collateral/putApprovedDocRcv',
    async (listApproval, thunkAPI) => {
        try {
            const response = await collateralService.putApprovedDocRcv(listApproval);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const putReturnDocRcv = createAsyncThunk(
    'collateral/putReturnDocRcv',
    async (listApproval, thunkAPI) => {
        try {
            const response = await collateralService.putReturnDocRcv(listApproval);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getRecIssueList = createAsyncThunk(
    'collateral/getRecIssueList',
    async (userInput, thunkAPI) => {
        try {
            const response = await collateralService.getRecIssueList(userInput);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getApprovalIssueList = createAsyncThunk(
    'collateral/getApprovalIssueList',
    async (userInput, thunkAPI) => {
        try {
            const response = await collateralService.getApprovalIssueList(userInput);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const saveDocIssue = createAsyncThunk(
    'collateral/saveDocIssue',
    async (payload, thunkAPI) => {
        try {
            const response = await collateralService.saveDocIssue(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getInquiryList = createAsyncThunk(
    'collateral/getInquiryList',
    async (userInput, thunkAPI) => {
        try {
            const response = await collateralService.getInquiryList(userInput);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);



export const putReqApprovalIssue = createAsyncThunk(
    'collateral/putReqApprovalIssue',
    async (listRequest, thunkAPI) => {
        try {
            const response = await collateralService.putReqApprovalIssue(listRequest);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const putApprovedIssue = createAsyncThunk(
    'collateral/putApprovedIssue',
    async (listApproval, thunkAPI) => {
        try {
            const response = await collateralService.putApprovedIssue(listApproval);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const putReturnIssue = createAsyncThunk(
    'collateral/putReturnIssue',
    async (listApproval, thunkAPI) => {
        try {
            const response = await collateralService.putReturnIssue(listApproval);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getChangeLocList = createAsyncThunk(
    'collateral/getChangeLocList',
    async (userInput, thunkAPI) => {
        try {
            const response = await collateralService.getChangeLocList(userInput);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const saveChangeLocDoc = createAsyncThunk(
    'collateral/saveChangeLocDoc',
    async (payload, thunkAPI) => {
        try {
            const response = await collateralService.saveChangeLocDoc(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const putReqApprovalChangeLoc = createAsyncThunk(
    'collateral/putReqApprovalChangeLoc',
    async (listApproval, thunkAPI) => {
        try {
            const response = await collateralService.putReqApprovalChangeLoc(listApproval);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const putApprovedChangeLoc = createAsyncThunk(
    'collateral/putApprovedChangeLoc',
    async (listApproval, thunkAPI) => {
        try {
            const response = await collateralService.putApprovedChangeLoc(listApproval);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const putReturnChangeLoc = createAsyncThunk(
    'collateral/putReturnChangeLoc',
    async (listApproval, thunkAPI) => {
        try {
            const response = await collateralService.putReturnChangeLoc(listApproval);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const getChangeLocApprovalList = createAsyncThunk(
    'collateral/getChangeLocApprovalList',
    async (userInput, thunkAPI) => {
        try {
            const response = await collateralService.getChangeLocApprovalList(userInput);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getHistoryLogCollateral = createAsyncThunk(
    'collateral/getHistoryLogCollateral',
    async (loanId, thunkAPI) => {
        try {
            return await collateralService.getHistoryLogCollateral(loanId);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);



const collateralSlice = createSlice({
    name: 'collateral',
    initialState,
    reducers: {
        showNotification: (state, action) => {
            state.showMessage = true;
            state.message = action.payload;
            state.loading = false;
        },  
        hideNotification: (state) => {
            state.showMessage = false;
            state.message = "";
        },
        showLoading: (state) => {
            state.isLoading = true;
        },
    },
    extraReducers: (builder) => {
        builder

            /* LIST TERIMA DOKUMEN */
            .addCase(docReceive.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(docReceive.fulfilled, (state, action) => {
                state.loading = false;
                state.docRecList = action.payload;
                state.getCount = action.payload.count;
            })
            .addCase(docReceive.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;   
            })

            /* TERIMA DOKUMEN DETAIL */
            .addCase(docReceiveDetail.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(docReceiveDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.docRecDetail = action.payload;
            })
            .addCase(docReceiveDetail.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })

            .addCase(getCabinetList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getCabinetList.fulfilled, (state, action) => {
                state.loading = false;
                state.cabinetList = action.payload;
                state.getCount = action.payload.count;
            })
            .addCase(getCabinetList.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;   
            })

            .addCase(getCabinetBoxList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getCabinetBoxList.fulfilled, (state, action) => {
                state.loading = false;
                state.cabinetBoxList = action.payload;
                state.getCount = action.payload.count;
            })
            .addCase(getCabinetBoxList.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })

            .addCase(saveLoanAsset.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(saveLoanAsset.fulfilled, (state, action) => {
                state.loading = false;
                state.result = action.payload;
            })
            .addCase(saveLoanAsset.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            
            .addCase(getDetailEdit.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getDetailEdit.fulfilled, (state, action) => {
                state.loading = false;
                state.detailEdit = action.payload;
            })
            .addCase(getDetailEdit.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })

            .addCase(putRequestApproval.pending, (state) => {
                state.loading = true;
            })
            .addCase(putRequestApproval.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putRequestApproval.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getRecApprovalList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getRecApprovalList.fulfilled, (state, action) => {
                state.loading = false;
                state.listApprovalRec = action.payload;
            })
            .addCase(getRecApprovalList.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })
            
            .addCase(putApprovedDocRcv.pending, (state) => {
                state.loading = true;
            })
            .addCase(putApprovedDocRcv.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putApprovedDocRcv.rejected, (state, action) => {
                state.loading = false;
            })
            
            .addCase(putReturnDocRcv.pending, (state) => {
                state.loading = true;
            })
            .addCase(putReturnDocRcv.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putReturnDocRcv.rejected, (state, action) => {
                state.loading = false;
            }) 

            .addCase(getRecIssueList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getRecIssueList.fulfilled, (state, action) => {
                state.loading = false;
                state.listIssue = action.payload;
            })
            .addCase(getRecIssueList.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })

            .addCase(getApprovalIssueList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getApprovalIssueList.fulfilled, (state, action) => {
                state.loading = false;
                state.listApprovalIssue = action.payload;
            })
            .addCase(getApprovalIssueList.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })

            .addCase(saveDocIssue.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(saveDocIssue.fulfilled, (state, action) => {
                state.loading = false;
                state.result = action.payload;
            })
            .addCase(saveDocIssue.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })

            
            .addCase(putReqApprovalIssue.pending, (state) => {
                state.loading = true;
            })
            .addCase(putReqApprovalIssue.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putReqApprovalIssue.rejected, (state, action) => {
                state.loading = false;
            })

            
            .addCase(putApprovedIssue.pending, (state) => {
                state.loading = true;
            })
            .addCase(putApprovedIssue.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putApprovedIssue.rejected, (state, action) => {
                state.loading = false;
            })

            
            .addCase(putReturnIssue.pending, (state) => {
                state.loading = true;
            })
            .addCase(putReturnIssue.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putReturnIssue.rejected, (state, action) => {
                state.loading = false;
            })

            
            .addCase(getChangeLocList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getChangeLocList.fulfilled, (state, action) => {
                state.loading = false;
                state.listChangeLoc = action.payload;
            })
            .addCase(getChangeLocList.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })   
            
            
            .addCase(saveChangeLocDoc.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(saveChangeLocDoc.fulfilled, (state, action) => {
                state.loading = false;
                state.result = action.payload;
            })
            .addCase(saveChangeLocDoc.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })

            
           .addCase(putReqApprovalChangeLoc.pending, (state) => {
                state.loading = true;
            })
            .addCase(putReqApprovalChangeLoc.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putReqApprovalChangeLoc.rejected, (state, action) => {
                state.loading = false;
            })         
            
            
            .addCase(putApprovedChangeLoc.pending, (state) => {
                state.loading = true;
            })
            .addCase(putApprovedChangeLoc.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putApprovedChangeLoc.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(putReturnChangeLoc.pending, (state) => {
                state.loading = true;
            })
            .addCase(putReturnChangeLoc.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(putReturnChangeLoc.rejected, (state, action) => {
                state.loading = false;
            })

            
            .addCase(getChangeLocApprovalList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getChangeLocApprovalList.fulfilled, (state, action) => {
                state.loading = false;
                state.listApprovalChangeLoc = action.payload;
            })
            .addCase(getChangeLocApprovalList.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })   

            .addCase(getHistoryLogCollateral.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getHistoryLogCollateral.fulfilled, (state, action) => {
                state.loading = false;
                state.logHistory = action.payload;
            })
            .addCase(getHistoryLogCollateral.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })

            .addCase(getInquiryList.pending, (state) => {
                state.loading = true;
                state.redirect = "";
            })
            .addCase(getInquiryList.fulfilled, (state, action) => {
                state.loading = false;
                state.listInquiry = action.payload;
            })
            .addCase(getInquiryList.rejected, (state, action) => {
                state.loading = false;
                state.isError = true;
                state.message = action.payload;
            })   
            

            ;    
    }
});

export const {
    showNotification,
    hideNotification,
    showLoading
} = collateralSlice.actions;

export default collateralSlice.reducer;